export class Keys{
    static CV='CV';
    static CL='CL';
}